import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class EquipmentService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of equipments based on hte given settings.
     *
     * @datatask 2039
     * @datataskName sp_ws_p2_equipment_select_list
     * @param params settings for retriving list
     * @returns promise containing list of equipements.
     */
    public getEquipments(params?: Partial<GetEquipmentsParams>): Promise<EquipmentItem[]> {
        return this.datatask.Post(2039, params);
    }

    /**
     * Retrieves list of equipments.
     *
     * @datatask 30
     * @datataskName sp_ws_p2_equipment_list
     * @param params
     * @returns promise containing list of equipments.
     */
    public getEquipmentList(params?: GetEquipmentListParams): Promise<EquipmentListItem[]> {
        return this.datatask.Post(30, params);
    }
}

export interface GetEquipmentListParams {
    operation_id?: string;
    businessco_no?: string | number;
    labour_no?: string | number;
}

export interface EquipmentListItem {
    item_id: string;
    item_name: string;
    orderby: string;
}

export interface GetEquipmentsParams {
    operation_id: string;
    factory_id: string;
    workgrp_keyno: string | number;
    businessco_no: string | number;
}

export interface EquipmentItem {
    item_id: string;
    item_name: string;
    orderby: string;
}
